import React from "react";
export default function Imprint() {
  return (
    <section className="py-10 bg-white">
      <div className="max-w-[1100px] mx-auto px-4 prose prose-slate">
        <h1>Impressum</h1>

        <p>
          <strong>Daraa Umzug</strong><br />
          Inhaber: Mohammad Alshabani<br />
          Alt-Friedrichsfelde 68<br />
          10315 Berlin<br />
          Deutschland
        </p>

        <p>
          Telefon: +49 176 41011065<br />
          E-Mail: mohammadalshabani@icloud.com
        </p>

        <p>
          <strong>Rechtsform:</strong><br />
          Einzelunternehmen (Kleinunternehmer nach §19 UStG)
        </p>

        <h2>Verbraucherstreitbeilegung</h2>
        <p>
          Wir sind weder verpflichtet noch bereit, an Streitbeilegungsverfahren vor
          einer Verbraucherschlichtungsstelle teilzunehmen (§ 36 VSBG).
        </p>

        <p className="text-sm opacity-70">
          Anbieterkennzeichnung gemäß § 5 Digitale-Dienste-Gesetz (DDG)
        </p>
      </div>
    </section>
  );
}
